"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.setStyle = setStyle;
exports.getStyle = exports.once = exports.off = exports.on = void 0;

var _vue = _interopRequireDefault(require("vue"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isServer = _vue["default"].prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};

var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

var on = function () {
  if (!isServer && document.addEventListener) {
    return function addEventListener(element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  }

  return function attachEvent(element, event, handler) {
    if (element && event && handler) {
      element.attachEvent("on".concat(event), handler);
    }
  };
}();

exports.on = on;

var off = function () {
  if (!isServer && document.removeEventListener) {
    return function removeEventListener(element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  }

  return function detachEvent(element, event, handler) {
    if (element && event) {
      element.detachEvent("on".concat(event), handler);
    }
  };
}();

exports.off = off;

var once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      fn.apply(_this, args);
    }

    off(el, event, listener);
  };

  on(el, event, listener);
};

exports.once = once;

function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');

  if (el.classList) {
    return el.classList.contains(cls);
  }

  return " ".concat(el.className, " ").indexOf(" ".concat(cls, " ")) > -1;
}

function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i += 1) {
    var clsName = classes[i];
    if (!clsName) continue; // eslint-disable-line no-continue

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += " ".concat(clsName);
    }
  }

  if (!el.classList) {
    el.className = curClass; // eslint-disable-line no-param-reassign
  }
}

function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = " ".concat(el.className, " ");

  for (var i = 0, j = classes.length; i < j; i += 1) {
    var clsName = classes[i];
    if (!clsName) continue; // eslint-disable-line no-continue

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(" ".concat(clsName, " "), ' ');
    }
  }

  if (!el.classList) {
    el.className = trim(curClass); // eslint-disable-line no-param-reassign
  }
}

var getStyle = function getStyle(element, styleName) {
  if (isServer || !element || !styleName) return null;
  var styleKey = camelCase(styleName);

  if (styleKey === 'float') {
    styleKey = 'cssFloat';
  }

  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleKey] || computed ? computed[styleKey] : null;
  } catch (e) {
    return element.style[styleKey];
  }
};

exports.getStyle = getStyle;

function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if (_typeof(styleName) === 'object') {
    Object.keys(styleName).forEach(function (prop) {
      setStyle(element, prop, styleName[prop]);
    });
  } else {
    var styleKey = camelCase(styleName);

    if (styleKey === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : "alpha(opacity=".concat(value * 100, ")"); // eslint-disable-line
    } else {
      element.style[styleKey] = value; // eslint-disable-line no-param-reassign
    }
  }
}